import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonService } from '../Services/common.service';

@Component({
    selector: 'app-policies',
    templateUrl: './policies.component.html',
    styleUrls: ['./policies.component.css'],
    standalone: false
})
export class PoliciesComponent implements OnInit, OnDestroy {
  isMobileView = false;
  subscription: Subscription;
  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
